export type BucketDto = {
  id: string;
  bucketName: string;
  bucketSize: number;
  objects: number;
  location: string;
  replicated: string;
  properties: string;
  accountName: string;
  created: string;
};

export type Bucket = {
  id: string;
  name: string;
  size: number;
  objects: number;
  location: string;
  replicated: boolean;
  properties: string;
  accountName: string;
  created: string;
  objectLock: boolean;
};
export const mapBucketDtoToBucket = (dto: BucketDto): Bucket => {
  return {
    id: dto.id,
    name: dto.bucketName,
    size: dto.bucketSize,
    objects: dto.objects,
    location: dto.location,
    replicated: dto.replicated === "Yes",
    properties: dto.properties,
    accountName: dto.accountName,
    created: dto.created,
    objectLock: dto.properties?.includes("Object lock") ?? false,
  };
};
